export const CommissionSplitSecondarySplitInfo = {
	agent: undefined,
	isPrivate: false,
	splitPercent: "0",
	isUseSecondaryAgentScheduleForCalculations: "false",
};
